import PuzzleTopBar from './PuzzleTopBar';

export default PuzzleTopBar;